import { request } from '@v4/http/request';
import { config } from '@v4/config';
import { getQueryParams } from '@v4/common/utils/url';

/**
 * Creates a lead
 *
 * @param {object} data
 *
 * @returns {Promise<*>}
 */
export const create = (data = {}) =>
    request(`${config.API_URL}/dkwp/v2/form/lead`, {
        method: 'POST',
        body: data,
    });

/**
 * Creates upsell lead (example of the usage in thank you page)
 *
 * @param {object} body
 *
 * @returns {Promise<*>}
 */
export const createUpsell = (body = {}) => {
    const formData = new FormData();
    Object.entries(body).forEach(([key, value]) => formData.append(`params[${key}]`, value));

    return request(`${config.API_URL}/dkwp/v1/handle-upsell-action`, {
        method: 'POST',
        body: formData,
        headers: {},
    });
};

/**
 * Creates multiple leads
 *
 * @param {object} data
 * @param {Array<object>} cars
 *
 * @returns {Promise<*>}
 */
export const createMultiple = (data = {}, vehicles = []) => {
    const newTypParam = getQueryParams().new_typ === '1' ? '?new_typ=1' : '';
    const url = `${config.API_URL}/dkwp/v2/form/multilead${newTypParam}`;

    return request(url, {
        method: 'POST',
        credentials: 'same-origin',
        body: {
            ...data,
            'dkwp[cars]': vehicles.map((vehicle) => ({
                maker: vehicle.makeName,
                model: vehicle.modelName,
                submodelId: vehicle.submodelId,
                price: vehicle.minPrice,
                basePrice: vehicle.minPrice,
                body: vehicle.bodyType,
                doors: vehicle.doors,
                year: vehicle.launchDate,
                poId: vehicle.poId,
                projectId: vehicle.projectId,
                promotionId: vehicle.promotionId
                    ? vehicle.promotionId
                    : vehicle.promotion
                        ? vehicle.promotion.id
                        : null,
            })),
        },
    });
};

/**
 * Gets form configs based on form ID and body data.
 *
 * @param {string} id - Form ID. Available values: `submodel`, `version`, `social-lp`, `widget`, `advisor`, `editorial`, `multimodel`, `single-offer`, `offer-landing`, `compare`, `dkpromo`
 * @param {object} body - HTTP body data.
 *
 * @returns {Promise<*>}
 */
export const getConfigs = (id = '', body = null) =>
    request(`${config.API_URL}/dkwp/v2/form/configs/${id}`, {
        method: 'POST',
        body,
    });
